import React, { useRef, useState, useEffect, useCallback, forwardRef, useImperativeHandle } from "react";
import { Spin, Select, Input, message, Modal, Button, Form } from "antd";
import { SearchOutlined, LoginOutlined } from "@ant-design/icons";
import styled from "styled-components";
import DoubleleftSvg from '@/img/doubleleft.svg';
import { useSelector } from "react-redux";
import OpenData from '@/components/open-data/open-data';
import apiConversation from "@/apis/pc/conversation/conversation";
import { debounceFunc, getWxMessageType, browser, throttle } from "@/utils/utils";
import _ from 'lodash';
import moment from "moment";
const { Option } = Select;
const { Search } = Input;
moment.defineLocale('zh-cn', {
  relativeTime: {
      future: '%s内',
      past: '%s前',
      s: '几秒',
      m: '1分钟',
      mm: '%d分钟',
      h: '1小时',
      hh: '%d小时',
      d: '1天',
      dd: '%d天',
      M: '1个月',
      MM: '%d个月',
      y: '1年',
      yy: '%d年'
  },
});

const Wrapper = styled.div`
  .user-item{
    display: flex;
    align-items: center;
    padding: 24px 24px 16px;
    .user-icon{
      width: 40px;
      height: 40px;
      border-radius: 4px;
      flex: none;
      margin-right: 8px;
    }
    .user-content{
      flex: 1;
      overflow: hidden;
      .user-content-top{
        line-height: 20px;
        display: flex;
        align-items: center;
        .user-name{
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #130928;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .user-label{
          margin-left: 4px;
          padding 0 4px;
          border-radius: 4px;
          background: #E5F1FE;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 12px;
          color: #52A5FC;
          flex: none;
        }
        .user-leave{
          background: #EBECF1;
          color: #9A9EBA;
        }
      }
      .user-dep{
        margin-top: 2px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #9A9EBA;
        line-height: 18px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .user-message{
      width: 32px;
      height: 18px;
      line-height: 18px;
      background: #FFFFFF;
      border-radius: 10px;
      border: 1px solid #E8EBF6;
      text-align: center;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #130928;
      flex: none;
      margin-left: 2px;
    }
  }

  .tab-box{
    display: flex;
    color: #767B9E;
    margin: 0 24px;
    margin-bottom: 16px;
    justify-content: space-between;
    border-bottom: 1px solid #E8EBF6;
    align-items: center;
    position: relative;
    .tab-item{
      flex: none;
      cursor: pointer;
      padding-bottom: 14px;
      font-weight: 400;
      font-size: 14px;
      color: #767B9E;
      line-height: 20px;
    }
    .tab-item-active{
      color: var(--ant-primary-color);
      position: relative;
      &::after{
        content: '';
        width: 100%;
        height: 4px;
        position: absolute;
        bottom: 0;
        left: 0;
        background-color: var(--ant-primary-color);
      }
    }
  }
    
  .search-box{
    padding: 0px 24px 16px;
    width: 100%;
    .ant-input-affix-wrapper{
      border-radius: 4px;
      border: 1px solid #E8EBF6;
    }
    .ant-input-affix-wrapper-focused{
      border: 1px solid var(--ant-primary-color);
    }
    .ant-input&::placeholder {
      color: #9A9EBA;
    }
    .ant-input-suffix{
      color: #9A9EBA;
    }
  }
`;

const covSearchMessageUserTab = forwardRef((props, ref) => {
  const { currentUser, onChange, wxUserid, customerId, isGroup, groupId } = props;
  
  useImperativeHandle(ref, () => ({
    getNextList: () => {
      setLoading(true);
      debounceGetNextList();
    },
    getInitList: () => {
      const { currentUser, onChange, wxUserid, customerId, isGroup, groupId } = props;
      if (isGroup) {
        setLoading(true);
        getOutGroupList();
      }else if (_.get(currentUser, 'uid', '')) {
        setLoading(true);
        getInitData();
      } else {
        outUserListRef.current = [];
        innerUserListRef.current = [];
        outGroupListRef.current = [];
        innerGroupListRef.current = [];
        setOutUser([]);
        setInnerUser([]);
        setOutGroup([]);
        setInnerGroupList([]);
      }
    },
  }));
  let ListTypeBtn = [
    { name: "外部好友", key: "1" },
    { name: "内部好友", key: "3" },
    { name: "外部群", key: "2" },
    { name: "内部群", key: "4" }
  ]
  if (wxUserid) {
    ListTypeBtn = [{ name: "单聊", key: "1" }]
  }
  if (isGroup) {
    ListTypeBtn = [{ name: "群聊", key: "2" }]
  }

  const [showAll, setShowAll] = useState(true); // 是否展示全部
  const [searchInput, setSearchInput] = useState(''); // 搜索关键词
  const [loading, setLoading] = useState(false); // 是否加载
  const [list, setList] = useState([]); // 当前查看的用户数据
  const [currentData, setCurrentData] = useState(null); // 当前查看的用户
  const [activeTab, setActiveTab] = useState(isGroup ? '2' : '1');
  const [outUser, setOutUser] = useState([]); // 企微客户列表对象
  const [innerUser, setInnerUser] = useState([]); // 内部好友列表对象
  const [outGroup, setOutGroup] = useState([]); // 外部群列表对象
  const [innerGroupList, setInnerGroupList] = useState([]); // 内部群列表对象

  
  const outUserRef = useRef({ pageSize: 50, chatType: 1, pageNum: 1, total: 0, nextPage: true, }); // 企微客户
  const innerUserRef = useRef({ pageSize: 50, chatType: 3, pageNum: 1, total: 0, nextPage: true, }); // 内部好友
  const outGroupRef = useRef({ pageSize: 50, chatType: 2, pageNum: 1, total: 0, nextPage: true, }); // 外部群
  const innerGroupRef = useRef({ pageSize: 50, chatType: 4, pageNum: 1, total: 0, nextPage: true, }); // 内部群
  const outUserListRef = useRef([]); // 企微客户
  const innerUserListRef = useRef([]); // 内部好友
  const outGroupListRef = useRef([]); // 外部群
  const innerGroupListRef = useRef([]); // 内部群
  const searchRef = useRef({ searchNameParam: '' }); // 搜索
  const activeTabRef = useRef(activeTab);
  let isFristLoading = useRef(true);
  let searchTimer = useRef(null);

  // 切换分类
  const changeTab = (key) => {
    setActiveTab(key);
  }

  

  // 获取企微客户列表
  const getOutConnectList = (pageNum) => {
    let obj = { uid: _.get(currentUser, 'uid', ''), ...outUserRef.current, }
    if (pageNum) {
      obj.pageNum = pageNum;
    }
    if (wxUserid) {
      obj.crmCustomerld = customerId;
      obj.extendUserld = wxUserid;
    }
    apiConversation
      .externaThirdlList(obj)
      .then((res) => {
        const { code, data } = res;
        if (code === 0) {
          const resetDataObj = resetData(data);
          const outUserList = resetDataObj?.list || [];
          // _.forEach(outUserList, item => {
          //   if (!item.corpName) {
          //     item.corpName = '微信'
          //   }
          // })
          outUserRef.current.pageNum = resetDataObj?.pageNum || 1;
          outUserRef.current.nextPage = resetDataObj?.nextPage || false;
          outUserRef.current.total = resetDataObj?.total || 0;
          let list = outUserList;
          if (resetDataObj?.pageNum !== 1) {
            list = outUserListRef.current;
            list = list.concat(outUserList);
          }
          outUserListRef.current = list;
          setOutUser(list);

        }
      }).finally(() => {
        setLoading(false);
      });
  };

  // 获取内部好友列表
  const getInnerUsertList = (pageNum) => {
    let obj = { uid: _.get(currentUser, 'uid', ''), ...innerUserRef.current, }
    if (pageNum) {
      obj.pageNum = pageNum;
    }
    apiConversation
      .externaThirdlList(obj)
      .then((res) => {
        const { code, data } = res;
        if (code === 0) {
          const resetDataObj = resetData(data);
          const innerUserList = resetDataObj?.list || [];
          innerUserRef.current.pageNum = resetDataObj?.pageNum || 1;
          innerUserRef.current.nextPage = resetDataObj?.nextPage || false;
          innerUserRef.current.total = resetDataObj?.total || 0;
          let list = innerUserList;
          if (resetDataObj?.pageNum !== 1) {
            list = innerUserListRef.current;
            list = list.concat(innerUserList);
          }
          innerUserListRef.current = list;
          setInnerUser(list);

        }
      }).finally(() => {
        setLoading(false);
      });
  };

  // 获取外部群列表
  const getOutGroupList = (pageNum) => {
    let obj = { uid: _.get(currentUser, 'uid', ''), ...outGroupRef.current, }
    if (pageNum) {
      obj.pageNum = pageNum;
    }
    if (isGroup) {
      obj.groupId = groupId;
    }
    return apiConversation
      .externalThirdGroupList(obj)
      .then((res) => {
        const { code, data } = res;
        if (code === 0) {
          
          isGroup && (isFristLoading.current = false)
          const resetDataObj = resetData(data);
          const outGroupList = resetDataObj?.list || [];
          outGroupRef.current.pageNum = resetDataObj?.pageNum || 1;
          outGroupRef.current.nextPage = resetDataObj?.nextPage || false;
          outGroupRef.current.total = resetDataObj?.total || 0;
          let list = outGroupList;
          if (resetDataObj?.pageNum !== 1) {
            list = outGroupListRef.current;
            list = list.concat(outGroupList);
          }
          outGroupListRef.current = list;
          setOutGroup(list);
        }
      }).finally(() => {
        setLoading(false);
      });
  };

  // 获取内部群列表
  const getInnerGroupList = (pageNum) => {
    let obj = { uid: _.get(currentUser, 'uid', ''), ...innerGroupRef.current, }
    if (pageNum) {
      obj.pageNum = pageNum;
    }
    return apiConversation
      .externalThirdGroupList(obj)
      .then((res) => {
        const { code, data } = res;
        if (code === 0) {
          const resetDataObj = resetData(data);
          const innerGroupList = resetDataObj?.list || [];
          innerGroupRef.current.pageNum = resetDataObj?.pageNum || 1;
          innerGroupRef.current.nextPage = resetDataObj?.nextPage || false;
          innerGroupRef.current.total = resetDataObj?.total || 0;
          let list = innerGroupList;
          if (resetDataObj?.pageNum !== 1) {
            list = innerGroupListRef.current;
            list = list.concat(innerGroupList);
          }
          innerGroupListRef.current = list;
          setInnerGroupList(list);
        }
      }).finally(() => {
        setLoading(false);
      });
  };

  

  const resetData = (data) => {
    const list = _.get(data, 'list', []);
    _.forEach(list, item => {
      item.lastMsgtypeStr = getWxMessageType(item.lastMsgtype);
      const fromNow =  moment(item.sortTime).fromNow()
      item.fromNow = fromNow;
      item.wxCreatetime = item.wxCreatetime ? moment(item.wxCreatetime).format('YYYY/MM/DD') : '';
    })
    data.list = list;
    return data;
  }

  const getInitData = async () => {
    setLoading(true);
    let initParams = { pageSize: 50, pageNum: 1, total: 0, nextPage: true, };
    outUserRef.current = {...initParams, chatType: 1};
    innerUserRef.current = {...initParams, chatType: 3};
    outGroupRef.current = {...initParams, chatType: 2};
    innerGroupRef.current = {...initParams, chatType: 4};
    getOutConnectList();
    getOutGroupList();
    getInnerGroupList();
    getInnerUsertList();
    isFristLoading.current = false;
  }

  
  // 获取下一页数据
  const getNextList = useCallback(() => {
    let hasNextPage = true;
    let pageNum = 1;
    let connectApi = getOutConnectList;
    if(activeTabRef.current == 1) {
      hasNextPage = outUserRef.current.nextPage;
      pageNum = outUserRef.current.pageNum + 1;
      connectApi = getOutConnectList;
    } else if(activeTabRef.current == 3) {
      hasNextPage = innerUserRef.current.nextPage;
      pageNum = innerUserRef.current.pageNum + 1;
      connectApi = getInnerUsertList;
    } else if(activeTabRef.current == 2) {
      hasNextPage = outGroupRef.current.nextPage;
      pageNum = outGroupRef.current.pageNum + 1;
      connectApi = getOutGroupList;
    } else if(activeTabRef.current == 4) {
      hasNextPage = innerGroupRef.current.nextPage;
      pageNum = innerGroupRef.current.pageNum + 1;
      connectApi = getInnerGroupList;
    }
    setLoading(false);
    if (!hasNextPage) return; // 没有下一页数据
    setLoading(true);
    connectApi(pageNum);
  }, [outUser, innerUser, outGroup, innerGroupList]);
  const debounceGetNextList = debounceFunc(getNextList, 300);
  const searchList = () => {
    searchRef.current.searchNameParam = searchInput;
    let searchParams = { pageNum: 1, total: 0, nextPage: true, ...searchRef.current }
    outUserRef.current = {...outUserRef.current, ...searchParams};
    // innerUserRef.current = {...innerUserRef.current, ...searchParams};
    outGroupRef.current = {...outGroupRef.current, ...searchParams};
    innerGroupRef.current = {...innerGroupRef.current, ...searchParams};
    getOutConnectList();
    getOutGroupList();
    getInnerGroupList();
    // getInnerUsertList();
  };

  useEffect(() => {
    if (isGroup) {
      setLoading(true);
      getOutGroupList();
    }else if (_.get(currentUser, 'uid', '')) {
      setLoading(true);
      getInitData();
    } else {
      outUserListRef.current = [];
      innerUserListRef.current = [];
      outGroupListRef.current = [];
      innerGroupListRef.current = [];
      setOutUser([]);
      setInnerUser([]);
      setOutGroup([]);
      setInnerGroupList([]);
    }
  }, [_.get(currentUser, 'uid', '')])

  
  useEffect(()=>{
    if (isFristLoading.current) return;
    if (searchTimer.current) clearTimeout(searchTimer.current);
    searchTimer.current = setTimeout(() => {
      clearTimeout(searchTimer.current);
      searchTimer.current = null;
      setLoading(true);
      searchList()
    }, 1000)
  },[searchInput])

  useEffect(() => {
    activeTabRef.current = activeTab;
    if (activeTab == 1) {
      onChange && onChange({
        msgList: outUser,
        activeTab: 1,
        chatId: _.get(outUser, '[0].sessionId', ''),
        item: _.get(outUser, '[0]', ''),
      })
    } else if (activeTab == 3) {
      onChange && onChange({
        msgList: innerUser,
        activeTab: 3,
        chatId: _.get(innerUser, '[0].sessionId', ''),
        item: _.get(innerUser, '[0]', ''),
      })
    } else if (activeTab == 2) {
      onChange && onChange({
        msgList: outGroup,
        activeTab: 2,
        chatId: _.get(outGroup, '[0].sessionId', ''),
        item: _.get(outGroup, '[0]', ''),
      })
    } else if (activeTab == 4) {
      onChange && onChange({
        msgList: innerGroupList,
        activeTab: 4,
        chatId: _.get(innerGroupList, '[0].sessionId', ''),
        item: _.get(innerGroupList, '[0]', ''),
      })
    }

  }, [outUser, innerUser, outGroup, innerGroupList, activeTab])
  return (
    <Spin
      spinning={loading}
    >
      <Wrapper>
        {
          isGroup ? null : (
            <div className={`user-item`}>
              {currentUser.avatarUrl ? <img className="user-icon" src={currentUser.avatarUrl} alt="" /> : null}
              <div className="user-content">
                <div className="user-content-top">
                  <div className="user-name">
                  <OpenData type="userName" openid={_.get(currentUser  , 'firstWxUserId', _.get(currentUser  , 'openWxUserid', ''))}>
                    {_.get(currentUser , 'name', '')}
                  </OpenData>
                  </div>
                  {
                    !_.get(currentUser, 'uid') ? null : !currentUser.status ? ( <div className="user-label user-leave">离职</div> ) : (
                        <div className="user-label">在职</div>
                      )
                  }
                  {/* <div>被继承</div> */}
                  
                </div>
                <div className="user-dep">{_.get(currentUser  , 'departmentName', '')}</div>
              </div>
            </div>
          )
        }
        
        <div className="tab-box">
          {
            ListTypeBtn.map(item => {
              return (
                <div
                  className={['tab-item', activeTab === item.key ? 'tab-item-active' : ''].join(' ')}
                  onClick={() => changeTab(item.key)}
                  key={item.key}
                >{item.name}</div>
              );
            })
          }
        </div>

        {
          ['3'].indexOf(activeTab) >= 0 ? null : (
            <div className="search-box">
              <Input
                placeholder={['1', '3'].indexOf(activeTab) >= 0 ? '搜索好友昵称' : '搜索群名称'}
                allowClear
                value={searchInput}
                onPressEnter={(e) => {
                  setSearchInput(e.target.value);
                }}
                onChange={(e) => {
                  setSearchInput(e.target.value);
                  // handleInput();
                }}
                suffix={
                  <SearchOutlined
                    style={{
                      color: '#9A9EBA',
                    }}
                  />
                }
              />
            </div>
          )
        }
      </Wrapper>
    </Spin>
  );
});

export default covSearchMessageUserTab;